import React, { Suspense, useState } from 'react';
import { Box } from "@mui/material";
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { CircleLoading } from 'components/loaders/Loaders';
import { PusherProvider } from 'hooks/usePusher';

function DashboardLayout() {

  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <PusherProvider>

      {/* ========== Header ========== */}
      <Header onMenuClick={() => setMobileOpen(true)} />

      <Box sx={{ display: 'flex' }}>

        {/* ========== Sidebar ========== */}
        <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />

        <Box component="main" sx={{ height: 'calc(100vh - 104px)', width: 1, position: 'relative', overflowY: 'auto', py: 2.5, px: 2 }}>
          <Suspense fallback={<CircleLoading />}>
            <Outlet />
          </Suspense>
        </Box>

      </Box>

    </PusherProvider>
  )
}

export default DashboardLayout